import { render, staticRenderFns } from "./AplicaBodegaVuelo.vue?vue&type=template&id=0378e29e&scoped=true&"
import script from "./AplicaBodegaVuelo.vue?vue&type=script&lang=js&"
export * from "./AplicaBodegaVuelo.vue?vue&type=script&lang=js&"
import style0 from "./AplicaBodegaVuelo.vue?vue&type=style&index=0&id=0378e29e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0378e29e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VCol,VRow})
